// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3SW80","info":"UpdateTermsInfo_info__2z-Db"};